@file:OptIn(InternalResourceApi::class)

package loco

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/loco/"

@delegate:ResourceContentHash(691_855_911)
public val Res.string.LOGIN_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:LOGIN_SCREEN_TITLE", "LOGIN_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5369, 34),
      ))
    }

@delegate:ResourceContentHash(-1_749_469_965)
public val Res.string.LOG_FOOD_ADD_MEAL_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:LOG_FOOD_ADD_MEAL_SCREEN_TITLE", "LOG_FOOD_ADD_MEAL_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5404, 54),
      ))
    }

@delegate:ResourceContentHash(667_917_817)
public val Res.string.LOG_FOOD_FIND_FOOD_EMPTY_MESSAGE: StringResource by lazy {
      StringResource("string:LOG_FOOD_FIND_FOOD_EMPTY_MESSAGE", "LOG_FOOD_FIND_FOOD_EMPTY_MESSAGE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5459, 92),
      ))
    }

@delegate:ResourceContentHash(-1_516_464_359)
public val Res.string.LOG_FOOD_FIND_FOOD_EMPTY_TITLE: StringResource by lazy {
      StringResource("string:LOG_FOOD_FIND_FOOD_EMPTY_TITLE", "LOG_FOOD_FIND_FOOD_EMPTY_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5552, 70),
      ))
    }

@delegate:ResourceContentHash(-929_205_458)
public val Res.string.LOG_FOOD_FIND_FOOD_SCAN_BARCODE_BUTTON: StringResource by lazy {
      StringResource("string:LOG_FOOD_FIND_FOOD_SCAN_BARCODE_BUTTON", "LOG_FOOD_FIND_FOOD_SCAN_BARCODE_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5623, 62),
      ))
    }

@delegate:ResourceContentHash(748_015_224)
public val Res.string.LOG_FOOD_FIND_FOOD_SEARCH_FIELD_PLACEHOLDER: StringResource by lazy {
      StringResource("string:LOG_FOOD_FIND_FOOD_SEARCH_FIELD_PLACEHOLDER", "LOG_FOOD_FIND_FOOD_SEARCH_FIELD_PLACEHOLDER", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5686, 63),
      ))
    }

@delegate:ResourceContentHash(-85_175_637)
public val Res.string.LOG_FOOD_FOOD_DETAILS_CALORIES_UNIT_LABEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_FOOD_DETAILS_CALORIES_UNIT_LABEL", "LOG_FOOD_FOOD_DETAILS_CALORIES_UNIT_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5750, 61),
      ))
    }

@delegate:ResourceContentHash(-1_317_193_678)
public val Res.string.LOG_FOOD_FOOD_DETAILS_CARBS_LABEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_FOOD_DETAILS_CARBS_LABEL", "LOG_FOOD_FOOD_DETAILS_CARBS_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5812, 49),
      ))
    }

@delegate:ResourceContentHash(1_181_004_125)
public val Res.string.LOG_FOOD_FOOD_DETAILS_FAT_LABEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_FOOD_DETAILS_FAT_LABEL", "LOG_FOOD_FOOD_DETAILS_FAT_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5862, 47),
      ))
    }

@delegate:ResourceContentHash(-1_973_101_085)
public val Res.string.LOG_FOOD_FOOD_DETAILS_FIBER_LABEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_FOOD_DETAILS_FIBER_LABEL", "LOG_FOOD_FOOD_DETAILS_FIBER_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5910, 49),
      ))
    }

@delegate:ResourceContentHash(1_006_450_738)
public val Res.string.LOG_FOOD_FOOD_DETAILS_PROTEIN_LABEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_FOOD_DETAILS_PROTEIN_LABEL", "LOG_FOOD_FOOD_DETAILS_PROTEIN_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5960, 55),
      ))
    }

@delegate:ResourceContentHash(1_337_258_347)
public val Res.string.LOG_SYMPTOMS_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:LOG_SYMPTOMS_SCREEN_TITLE", "LOG_SYMPTOMS_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6016, 49),
      ))
    }

@delegate:ResourceContentHash(111_733_814)
public val Res.string.LOG_WATER_CLOSE_BUTTON: StringResource by lazy {
      StringResource("string:LOG_WATER_CLOSE_BUTTON", "LOG_WATER_CLOSE_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6066, 38),
      ))
    }

@delegate:ResourceContentHash(901_813_437)
public val Res.string.LOG_WATER_PERSONAL_AMOUNT_LABEL: StringResource by lazy {
      StringResource("string:LOG_WATER_PERSONAL_AMOUNT_LABEL", "LOG_WATER_PERSONAL_AMOUNT_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6105, 79),
      ))
    }

@delegate:ResourceContentHash(-1_234_414_839)
public val Res.string.LOG_WATER_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:LOG_WATER_SCREEN_TITLE", "LOG_WATER_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6185, 46),
      ))
    }

@delegate:ResourceContentHash(-359_218_434)
public val Res.string.MAIN_NAVIGATION_CHAT_LABEL: StringResource by lazy {
      StringResource("string:MAIN_NAVIGATION_CHAT_LABEL", "MAIN_NAVIGATION_CHAT_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6232, 42),
      ))
    }

@delegate:ResourceContentHash(1_875_245_623)
public val Res.string.MAIN_NAVIGATION_DAILY_LABEL: StringResource by lazy {
      StringResource("string:MAIN_NAVIGATION_DAILY_LABEL", "MAIN_NAVIGATION_DAILY_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6275, 43),
      ))
    }

@delegate:ResourceContentHash(1_537_355_486)
public val Res.string.MAIN_NAVIGATION_INSIGHTS_LABEL: StringResource by lazy {
      StringResource("string:MAIN_NAVIGATION_INSIGHTS_LABEL", "MAIN_NAVIGATION_INSIGHTS_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6319, 50),
      ))
    }

@delegate:ResourceContentHash(-1_913_882_926)
public val Res.string.MAIN_NAVIGATION_MAIN_LABEL: StringResource by lazy {
      StringResource("string:MAIN_NAVIGATION_MAIN_LABEL", "MAIN_NAVIGATION_MAIN_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6370, 42),
      ))
    }

@delegate:ResourceContentHash(2_588_747)
public val Res.string.MAIN_NAVIGATION_ME_LABEL: StringResource by lazy {
      StringResource("string:MAIN_NAVIGATION_ME_LABEL", "MAIN_NAVIGATION_ME_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6413, 36),
      ))
    }

@delegate:ResourceContentHash(-120_496_940)
public val Res.string.MAIN_NAVIGATION_TODAY_LABEL: StringResource by lazy {
      StringResource("string:MAIN_NAVIGATION_TODAY_LABEL", "MAIN_NAVIGATION_TODAY_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6450, 43),
      ))
    }

@delegate:ResourceContentHash(2_572_552)
public val Res.string.MEAL_PLAN_LOG_FOOD_BUTTON: StringResource by lazy {
      StringResource("string:MEAL_PLAN_LOG_FOOD_BUTTON", "MEAL_PLAN_LOG_FOOD_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6494, 37),
      ))
    }

@delegate:ResourceContentHash(-120_496_940)
public val Res.string.MED_TODAY_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:MED_TODAY_SCREEN_TITLE", "MED_TODAY_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6532, 38),
      ))
    }

@delegate:ResourceContentHash(-305_839_859)
public val Res.string.ME_BMI_GOAL_VALUE_FORMAT: StringResource by lazy {
      StringResource("string:ME_BMI_GOAL_VALUE_FORMAT", "ME_BMI_GOAL_VALUE_FORMAT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6571, 48),
      ))
    }

@delegate:ResourceContentHash(-285_580_462)
public val Res.string.ME_CALORIES_HISTORY_SECTION: StringResource by lazy {
      StringResource("string:ME_CALORIES_HISTORY_SECTION", "ME_CALORIES_HISTORY_SECTION", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6620, 55),
      ))
    }

@delegate:ResourceContentHash(926_642_611)
public val Res.string.ME_DAYS_IN_A_ROW_LABEL: StringResource by lazy {
      StringResource("string:ME_DAYS_IN_A_ROW_LABEL", "ME_DAYS_IN_A_ROW_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6676, 50),
      ))
    }

@delegate:ResourceContentHash(-1_787_344_029)
public val Res.string.ME_DAYS_IN_A_ROW_VALUE: StringResource by lazy {
      StringResource("string:ME_DAYS_IN_A_ROW_VALUE", "ME_DAYS_IN_A_ROW_VALUE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6727, 42),
      ))
    }

@delegate:ResourceContentHash(1_790_218_702)
public val Res.string.ME_SCREEN_TITLE_FORMAT: StringResource by lazy {
      StringResource("string:ME_SCREEN_TITLE_FORMAT", "ME_SCREEN_TITLE_FORMAT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6770, 42),
      ))
    }

@delegate:ResourceContentHash(1_709_274_745)
public val Res.string.ME_WEIGHT_HISTORY_SECTION: StringResource by lazy {
      StringResource("string:ME_WEIGHT_HISTORY_SECTION", "ME_WEIGHT_HISTORY_SECTION", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6813, 53),
      ))
    }

@delegate:ResourceContentHash(1_933_465_876)
public val Res.string.ME_WEIGHT_LOSS_PROGRESS_SECTION: StringResource by lazy {
      StringResource("string:ME_WEIGHT_LOSS_PROGRESS_SECTION", "ME_WEIGHT_LOSS_PROGRESS_SECTION", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6867, 67),
      ))
    }

@delegate:ResourceContentHash(-1_999_677_814)
public val Res.string.ME_WEIGHT_LOSS_PROGRESS_VALUE_FORMAT: StringResource by lazy {
      StringResource("string:ME_WEIGHT_LOSS_PROGRESS_VALUE_FORMAT", "ME_WEIGHT_LOSS_PROGRESS_VALUE_FORMAT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6935, 56),
      ))
    }

@delegate:ResourceContentHash(2_128_803_808)
public val Res.string.ONBOARDING_SIGN_IN_BUTTON: StringResource by lazy {
      StringResource("string:ONBOARDING_SIGN_IN_BUTTON", "ONBOARDING_SIGN_IN_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6992, 69),
      ))
    }

@delegate:ResourceContentHash(-1_878_414_682)
public val Res.string.ONBOARDING_WELCOME_NO_ACCOUNT_BUTTON: StringResource by lazy {
      StringResource("string:ONBOARDING_WELCOME_NO_ACCOUNT_BUTTON", "ONBOARDING_WELCOME_NO_ACCOUNT_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7062, 68),
      ))
    }

@delegate:ResourceContentHash(2_017_706_663)
public val Res.string.ONBOARDING_WELCOME_SIGN_IN_BUTTON: StringResource by lazy {
      StringResource("string:ONBOARDING_WELCOME_SIGN_IN_BUTTON", "ONBOARDING_WELCOME_SIGN_IN_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7131, 53),
      ))
    }

@delegate:ResourceContentHash(61_347_966)
public val Res.string.ONBOARDING_WELLNESS_PROFILE_BMI_GRAPH_LABEL: StringResource by lazy {
      StringResource("string:ONBOARDING_WELLNESS_PROFILE_BMI_GRAPH_LABEL", "ONBOARDING_WELLNESS_PROFILE_BMI_GRAPH_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7185, 79),
      ))
    }

@delegate:ResourceContentHash(1_604_991_803)
public val Res.string.ONBOARDING_WELLNESS_PROFILE_YOUR_BMI_FORMAT: StringResource by lazy {
      StringResource("string:ONBOARDING_WELLNESS_PROFILE_YOUR_BMI_FORMAT", "ONBOARDING_WELLNESS_PROFILE_YOUR_BMI_FORMAT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7265, 67),
      ))
    }

@delegate:ResourceContentHash(-1_209_331_196)
public val Res.string.PAYWALL_OTHER_PLANS_BUTTON: StringResource by lazy {
      StringResource("string:PAYWALL_OTHER_PLANS_BUTTON", "PAYWALL_OTHER_PLANS_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7333, 54),
      ))
    }

@delegate:ResourceContentHash(-2_131_866_606)
public val Res.string.PAYWALL_PRIVACY_BUTTON: StringResource by lazy {
      StringResource("string:PAYWALL_PRIVACY_BUTTON", "PAYWALL_PRIVACY_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7388, 42),
      ))
    }

@delegate:ResourceContentHash(558_345_074)
public val Res.string.PAYWALL_RESTORE_BUTTON: StringResource by lazy {
      StringResource("string:PAYWALL_RESTORE_BUTTON", "PAYWALL_RESTORE_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7431, 54),
      ))
    }

@delegate:ResourceContentHash(691_127_343)
public val Res.string.PAYWALL_SIGN_IN_BUTTON: StringResource by lazy {
      StringResource("string:PAYWALL_SIGN_IN_BUTTON", "PAYWALL_SIGN_IN_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7486, 38),
      ))
    }

@delegate:ResourceContentHash(722_944_922)
public val Res.string.PAYWALL_TERMS_BUTTON: StringResource by lazy {
      StringResource("string:PAYWALL_TERMS_BUTTON", "PAYWALL_TERMS_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7525, 36),
      ))
    }

@delegate:ResourceContentHash(194_379_606)
public val Res.string.PCOS_TODAY_HEALTH_ADVICE_EMPTY_TEXT: StringResource by lazy {
      StringResource("string:PCOS_TODAY_HEALTH_ADVICE_EMPTY_TEXT", "PCOS_TODAY_HEALTH_ADVICE_EMPTY_TEXT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7562, 167),
      ))
    }

@delegate:ResourceContentHash(297_022_549)
public val Res.string.PCOS_TODAY_LOG_SYMPTOMS_LABEL: StringResource by lazy {
      StringResource("string:PCOS_TODAY_LOG_SYMPTOMS_LABEL", "PCOS_TODAY_LOG_SYMPTOMS_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7730, 53),
      ))
    }

@delegate:ResourceContentHash(947_518_009)
public val Res.string.PILATES_TODAY_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:PILATES_TODAY_SCREEN_TITLE", "PILATES_TODAY_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7784, 46),
      ))
    }

@delegate:ResourceContentHash(947_518_009)
public val Res.string.PILATES_TODAY_WORKOUTS_SECTION: StringResource by lazy {
      StringResource("string:PILATES_TODAY_WORKOUTS_SECTION", "PILATES_TODAY_WORKOUTS_SECTION", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7831, 50),
      ))
    }

@delegate:ResourceContentHash(-1_053_197_395)
public val Res.string.RATE_US_ALERT_MESSAGE: StringResource by lazy {
      StringResource("string:RATE_US_ALERT_MESSAGE", "RATE_US_ALERT_MESSAGE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7882, 133),
      ))
    }

@delegate:ResourceContentHash(-244_376_310)
public val Res.string.RATE_US_ALERT_NEGATIVE_BUTTON: StringResource by lazy {
      StringResource("string:RATE_US_ALERT_NEGATIVE_BUTTON", "RATE_US_ALERT_NEGATIVE_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8016, 49),
      ))
    }

@delegate:ResourceContentHash(2_678_212)
public val Res.string.RATE_US_ALERT_POSITIVE_BUTTON: StringResource by lazy {
      StringResource("string:RATE_US_ALERT_POSITIVE_BUTTON", "RATE_US_ALERT_POSITIVE_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8066, 41),
      ))
    }

@delegate:ResourceContentHash(1_606_292_617)
public val Res.string.RATE_US_ALERT_TITLE_FORMAT: StringResource by lazy {
      StringResource("string:RATE_US_ALERT_TITLE_FORMAT", "RATE_US_ALERT_TITLE_FORMAT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8108, 58),
      ))
    }

@delegate:ResourceContentHash(2_608_990)
public val Res.string.RATE_US_IMPROVE_ALERT_NEGATIVE_BUTTON: StringResource by lazy {
      StringResource("string:RATE_US_IMPROVE_ALERT_NEGATIVE_BUTTON", "RATE_US_IMPROVE_ALERT_NEGATIVE_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8167, 49),
      ))
    }

@delegate:ResourceContentHash(2_678_212)
public val Res.string.RATE_US_IMPROVE_ALERT_POSITIVE_BUTTON: StringResource by lazy {
      StringResource("string:RATE_US_IMPROVE_ALERT_POSITIVE_BUTTON", "RATE_US_IMPROVE_ALERT_POSITIVE_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8217, 49),
      ))
    }

@delegate:ResourceContentHash(1_242_787_730)
public val Res.string.RATE_US_IMPROVE_ALERT_TITLE: StringResource by lazy {
      StringResource("string:RATE_US_IMPROVE_ALERT_TITLE", "RATE_US_IMPROVE_ALERT_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8267, 95),
      ))
    }

@delegate:ResourceContentHash(1_567_724_178)
public val Res.string.SETTINGS_ABOUT_PRODUCT_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_ABOUT_PRODUCT_LABEL", "SETTINGS_ABOUT_PRODUCT_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8363, 44),
      ))
    }

@delegate:ResourceContentHash(-1_757_122_133)
public val Res.string.SETTINGS_CONTACT_US_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_CONTACT_US_LABEL", "SETTINGS_CONTACT_US_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8408, 49),
      ))
    }

@delegate:ResourceContentHash(-1_944_597_206)
public val Res.string.SETTINGS_DELETE_ACCOUNT_ALERT_MESSAGE: StringResource by lazy {
      StringResource("string:SETTINGS_DELETE_ACCOUNT_ALERT_MESSAGE", "SETTINGS_DELETE_ACCOUNT_ALERT_MESSAGE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8458, 121),
      ))
    }

@delegate:ResourceContentHash(-177_594_565)
public val Res.string.SETTINGS_DELETE_ACCOUNT_ALERT_TITLE: StringResource by lazy {
      StringResource("string:SETTINGS_DELETE_ACCOUNT_ALERT_TITLE", "SETTINGS_DELETE_ACCOUNT_ALERT_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8580, 91),
      ))
    }

@delegate:ResourceContentHash(-1_446_557_603)
public val Res.string.SETTINGS_DELETE_ACCOUNT_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_DELETE_ACCOUNT_LABEL", "SETTINGS_DELETE_ACCOUNT_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8672, 73),
      ))
    }

@delegate:ResourceContentHash(-1_320_945_082)
public val Res.string.SETTINGS_DELETE_ACCOUNT_NEGATIVE_BUTTON: StringResource by lazy {
      StringResource("string:SETTINGS_DELETE_ACCOUNT_NEGATIVE_BUTTON", "SETTINGS_DELETE_ACCOUNT_NEGATIVE_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8746, 55),
      ))
    }

@delegate:ResourceContentHash(1_719_982_172)
public val Res.string.SETTINGS_DELETE_ACCOUNT_POSITIVE_BUTTON: StringResource by lazy {
      StringResource("string:SETTINGS_DELETE_ACCOUNT_POSITIVE_BUTTON", "SETTINGS_DELETE_ACCOUNT_POSITIVE_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8802, 75),
      ))
    }

@delegate:ResourceContentHash(-1_744_800_486)
public val Res.string.SETTINGS_GENERAL_SECTION: StringResource by lazy {
      StringResource("string:SETTINGS_GENERAL_SECTION", "SETTINGS_GENERAL_SECTION", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8878, 44),
      ))
    }

@delegate:ResourceContentHash(1_521_865_039)
public val Res.string.SETTINGS_LEGAL_PRODUCT_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_LEGAL_PRODUCT_LABEL", "SETTINGS_LEGAL_PRODUCT_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8923, 44),
      ))
    }

@delegate:ResourceContentHash(691_852_147)
public val Res.string.SETTINGS_LOGOUT_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_LOGOUT_LABEL", "SETTINGS_LOGOUT_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8968, 37),
      ))
    }

@delegate:ResourceContentHash(-1_376_185_488)
public val Res.string.SETTINGS_MANAGE_SUBSCRIPTION_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_MANAGE_SUBSCRIPTION_LABEL", "SETTINGS_MANAGE_SUBSCRIPTION_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9006, 70),
      ))
    }

@delegate:ResourceContentHash(-2_142_555_969)
public val Res.string.SETTINGS_MEAL_PLAN_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_MEAL_PLAN_LABEL", "SETTINGS_MEAL_PLAN_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9077, 44),
      ))
    }

@delegate:ResourceContentHash(838_096_846)
public val Res.string.SETTINGS_MEAL_PLAN_SETTINGS_OTHER_SECTION: StringResource by lazy {
      StringResource("string:SETTINGS_MEAL_PLAN_SETTINGS_OTHER_SECTION", "SETTINGS_MEAL_PLAN_SETTINGS_OTHER_SECTION", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9122, 57),
      ))
    }

@delegate:ResourceContentHash(-1_906_452_653)
public val Res.string.SETTINGS_MEAL_PLAN_SETTINGS_PERSONAL_SECTION: StringResource by lazy {
      StringResource("string:SETTINGS_MEAL_PLAN_SETTINGS_PERSONAL_SECTION", "SETTINGS_MEAL_PLAN_SETTINGS_PERSONAL_SECTION", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9180, 68),
      ))
    }

@delegate:ResourceContentHash(-203_793_513)
public val Res.string.SETTINGS_MEAL_PLAN_SETTINGS_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:SETTINGS_MEAL_PLAN_SETTINGS_SCREEN_TITLE", "SETTINGS_MEAL_PLAN_SETTINGS_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9249, 76),
      ))
    }

@delegate:ResourceContentHash(-381_704_478)
public val Res.string.SETTINGS_METRICS_SYSTEM_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_METRICS_SYSTEM_LABEL", "SETTINGS_METRICS_SYSTEM_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9326, 57),
      ))
    }

@delegate:ResourceContentHash(-127_523_211)
public val Res.string.SETTINGS_PERIOD_TRACKER_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_PERIOD_TRACKER_LABEL", "SETTINGS_PERIOD_TRACKER_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9384, 57),
      ))
    }

@delegate:ResourceContentHash(2_499_886)
public val Res.string.SETTINGS_PROFILE_AGE_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_PROFILE_AGE_LABEL", "SETTINGS_PROFILE_AGE_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9442, 38),
      ))
    }

@delegate:ResourceContentHash(-219_104_498)
public val Res.string.SETTINGS_PROFILE_HEIGHT_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_PROFILE_HEIGHT_LABEL", "SETTINGS_PROFILE_HEIGHT_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9481, 45),
      ))
    }

@delegate:ResourceContentHash(-555_649_726)
public val Res.string.SETTINGS_PROFILE_INITIAL_WEIGHT_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_PROFILE_INITIAL_WEIGHT_LABEL", "SETTINGS_PROFILE_INITIAL_WEIGHT_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9527, 65),
      ))
    }

@delegate:ResourceContentHash(434_763_486)
public val Res.string.SETTINGS_PROFILE_NAME_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_PROFILE_NAME_LABEL", "SETTINGS_PROFILE_NAME_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9593, 43),
      ))
    }

@delegate:ResourceContentHash(755_966_064)
public val Res.string.SETTINGS_PROFILE_SECTION: StringResource by lazy {
      StringResource("string:SETTINGS_PROFILE_SECTION", "SETTINGS_PROFILE_SECTION", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9637, 44),
      ))
    }

@delegate:ResourceContentHash(1_091_268_187)
public val Res.string.SETTINGS_PROFILE_TARGET_WEIGHT_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_PROFILE_TARGET_WEIGHT_LABEL", "SETTINGS_PROFILE_TARGET_WEIGHT_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9682, 64),
      ))
    }

@delegate:ResourceContentHash(2_128_440_428)
public val Res.string.SETTINGS_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:SETTINGS_SCREEN_TITLE", "SETTINGS_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9747, 41),
      ))
    }

@delegate:ResourceContentHash(2_500_513)
public val Res.string.SHOPPING_LIST_CATEGORY_ALL_LABEL: StringResource by lazy {
      StringResource("string:SHOPPING_LIST_CATEGORY_ALL_LABEL", "SHOPPING_LIST_CATEGORY_ALL_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9789, 44),
      ))
    }

@delegate:ResourceContentHash(1_507_453_160)
public val Res.string.SHOPPING_LIST_CHECKED_SECTION: StringResource by lazy {
      StringResource("string:SHOPPING_LIST_CHECKED_SECTION", "SHOPPING_LIST_CHECKED_SECTION", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9834, 45),
      ))
    }

@delegate:ResourceContentHash(-641_568_803)
public val Res.string.SHOPPING_LIST_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:SHOPPING_LIST_SCREEN_TITLE", "SHOPPING_LIST_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9880, 54),
      ))
    }

@delegate:ResourceContentHash(-152_799_692)
public val Res.string.SHOPPING_LIST_UNCHECKED_SECTION: StringResource by lazy {
      StringResource("string:SHOPPING_LIST_UNCHECKED_SECTION", "SHOPPING_LIST_UNCHECKED_SECTION", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9935, 47),
      ))
    }

@delegate:ResourceContentHash(1_871_100_427)
public val Res.string.TODAY_ACTIVITY_LABEL: StringResource by lazy {
      StringResource("string:TODAY_ACTIVITY_LABEL", "TODAY_ACTIVITY_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9983, 40),
      ))
    }

@delegate:ResourceContentHash(-678_846_169)
public val Res.string.TODAY_LOGGED_SYMPTOMS_LABEL: StringResource by lazy {
      StringResource("string:TODAY_LOGGED_SYMPTOMS_LABEL", "TODAY_LOGGED_SYMPTOMS_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10024, 43),
      ))
    }

@delegate:ResourceContentHash(-378_609_148)
public val Res.string.TODAY_LOG_CONTROLS_SECTION: StringResource by lazy {
      StringResource("string:TODAY_LOG_CONTROLS_SECTION", "TODAY_LOG_CONTROLS_SECTION", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10068, 54),
      ))
    }

@delegate:ResourceContentHash(-691_387_618)
public val Res.string.TODAY_LOG_FOOD_BUTTON: StringResource by lazy {
      StringResource("string:TODAY_LOG_FOOD_BUTTON", "TODAY_LOG_FOOD_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10123, 41),
      ))
    }

@delegate:ResourceContentHash(1_337_258_347)
public val Res.string.TODAY_LOG_SYMPTOMS_LABEL: StringResource by lazy {
      StringResource("string:TODAY_LOG_SYMPTOMS_LABEL", "TODAY_LOG_SYMPTOMS_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10165, 48),
      ))
    }

@delegate:ResourceContentHash(469_558_257)
public val Res.string.TODAY_LOG_WATER_BUTTON: StringResource by lazy {
      StringResource("string:TODAY_LOG_WATER_BUTTON", "TODAY_LOG_WATER_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10214, 42),
      ))
    }

@delegate:ResourceContentHash(-915_485_875)
public val Res.string.TODAY_LOG_WEIGHT_BUTTON: StringResource by lazy {
      StringResource("string:TODAY_LOG_WEIGHT_BUTTON", "TODAY_LOG_WEIGHT_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10257, 47),
      ))
    }

@delegate:ResourceContentHash(2_103_235_382)
public val Res.string.TODAY_MEALS_SECTION: StringResource by lazy {
      StringResource("string:TODAY_MEALS_SECTION", "TODAY_MEALS_SECTION", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10305, 43),
      ))
    }

@delegate:ResourceContentHash(-487_684_047)
public val Res.string.TODAY_MEAL_PLAN_SECTION: StringResource by lazy {
      StringResource("string:TODAY_MEAL_PLAN_SECTION", "TODAY_MEAL_PLAN_SECTION", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10349, 51),
      ))
    }

@delegate:ResourceContentHash(-1_234_414_839)
public val Res.string.TODAY_WATER_INTAKE_LABEL: StringResource by lazy {
      StringResource("string:TODAY_WATER_INTAKE_LABEL", "TODAY_WATER_INTAKE_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10401, 48),
      ))
    }

@delegate:ResourceContentHash(111_733_814)
public val Res.string.TODAY_WATER_INTAKE_SHEET_CLOSE_BUTTON: StringResource by lazy {
      StringResource("string:TODAY_WATER_INTAKE_SHEET_CLOSE_BUTTON", "TODAY_WATER_INTAKE_SHEET_CLOSE_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10450, 53),
      ))
    }

@delegate:ResourceContentHash(901_813_437)
public val Res.string.TODAY_WATER_INTAKE_SHEET_DAILY_AMOUNT_LABEL: StringResource by lazy {
      StringResource("string:TODAY_WATER_INTAKE_SHEET_DAILY_AMOUNT_LABEL", "TODAY_WATER_INTAKE_SHEET_DAILY_AMOUNT_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10504, 91),
      ))
    }

@delegate:ResourceContentHash(-1_234_414_839)
public val Res.string.TODAY_WATER_INTAKE_SHEET_TITLE: StringResource by lazy {
      StringResource("string:TODAY_WATER_INTAKE_SHEET_TITLE", "TODAY_WATER_INTAKE_SHEET_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10596, 54),
      ))
    }

@delegate:ResourceContentHash(-743_348_906)
public val Res.string.TODAY_WEIGHT_LABEL: StringResource by lazy {
      StringResource("string:TODAY_WEIGHT_LABEL", "TODAY_WEIGHT_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10651, 34),
      ))
    }

@delegate:ResourceContentHash(1_908_875_464)
public val Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_DESCRIPTION: StringResource by lazy {
      StringResource("string:TUTORIAL_PERSONAL_MEAL_PLAN_DESCRIPTION", "TUTORIAL_PERSONAL_MEAL_PLAN_DESCRIPTION", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10686, 259),
      ))
    }

@delegate:ResourceContentHash(-1_019_199_737)
public val Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_NEGATIVE_BUTTON: StringResource by lazy {
      StringResource("string:TUTORIAL_PERSONAL_MEAL_PLAN_NEGATIVE_BUTTON", "TUTORIAL_PERSONAL_MEAL_PLAN_NEGATIVE_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10946, 67),
      ))
    }

@delegate:ResourceContentHash(895_292_232)
public val Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_POSITIVE_BUTTON: StringResource by lazy {
      StringResource("string:TUTORIAL_PERSONAL_MEAL_PLAN_POSITIVE_BUTTON", "TUTORIAL_PERSONAL_MEAL_PLAN_POSITIVE_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11014, 67),
      ))
    }

@delegate:ResourceContentHash(707_334_620)
public val Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_TITLE: StringResource by lazy {
      StringResource("string:TUTORIAL_PERSONAL_MEAL_PLAN_TITLE", "TUTORIAL_PERSONAL_MEAL_PLAN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11082, 81),
      ))
    }

@delegate:ResourceContentHash(1_344_273_123)
public val Res.string.UPDATE_AGE_INFO: StringResource by lazy {
      StringResource("string:UPDATE_AGE_INFO", "UPDATE_AGE_INFO", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11164, 95),
      ))
    }

@delegate:ResourceContentHash(-1_810_497_356)
public val Res.string.UPDATE_AGE_LOW_AGE_ERROR: StringResource by lazy {
      StringResource("string:UPDATE_AGE_LOW_AGE_ERROR", "UPDATE_AGE_LOW_AGE_ERROR", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11260, 68),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("LOGIN_SCREEN_TITLE", Res.string.LOGIN_SCREEN_TITLE)
  map.put("LOG_FOOD_ADD_MEAL_SCREEN_TITLE", Res.string.LOG_FOOD_ADD_MEAL_SCREEN_TITLE)
  map.put("LOG_FOOD_FIND_FOOD_EMPTY_MESSAGE", Res.string.LOG_FOOD_FIND_FOOD_EMPTY_MESSAGE)
  map.put("LOG_FOOD_FIND_FOOD_EMPTY_TITLE", Res.string.LOG_FOOD_FIND_FOOD_EMPTY_TITLE)
  map.put("LOG_FOOD_FIND_FOOD_SCAN_BARCODE_BUTTON", Res.string.LOG_FOOD_FIND_FOOD_SCAN_BARCODE_BUTTON)
  map.put("LOG_FOOD_FIND_FOOD_SEARCH_FIELD_PLACEHOLDER", Res.string.LOG_FOOD_FIND_FOOD_SEARCH_FIELD_PLACEHOLDER)
  map.put("LOG_FOOD_FOOD_DETAILS_CALORIES_UNIT_LABEL", Res.string.LOG_FOOD_FOOD_DETAILS_CALORIES_UNIT_LABEL)
  map.put("LOG_FOOD_FOOD_DETAILS_CARBS_LABEL", Res.string.LOG_FOOD_FOOD_DETAILS_CARBS_LABEL)
  map.put("LOG_FOOD_FOOD_DETAILS_FAT_LABEL", Res.string.LOG_FOOD_FOOD_DETAILS_FAT_LABEL)
  map.put("LOG_FOOD_FOOD_DETAILS_FIBER_LABEL", Res.string.LOG_FOOD_FOOD_DETAILS_FIBER_LABEL)
  map.put("LOG_FOOD_FOOD_DETAILS_PROTEIN_LABEL", Res.string.LOG_FOOD_FOOD_DETAILS_PROTEIN_LABEL)
  map.put("LOG_SYMPTOMS_SCREEN_TITLE", Res.string.LOG_SYMPTOMS_SCREEN_TITLE)
  map.put("LOG_WATER_CLOSE_BUTTON", Res.string.LOG_WATER_CLOSE_BUTTON)
  map.put("LOG_WATER_PERSONAL_AMOUNT_LABEL", Res.string.LOG_WATER_PERSONAL_AMOUNT_LABEL)
  map.put("LOG_WATER_SCREEN_TITLE", Res.string.LOG_WATER_SCREEN_TITLE)
  map.put("MAIN_NAVIGATION_CHAT_LABEL", Res.string.MAIN_NAVIGATION_CHAT_LABEL)
  map.put("MAIN_NAVIGATION_DAILY_LABEL", Res.string.MAIN_NAVIGATION_DAILY_LABEL)
  map.put("MAIN_NAVIGATION_INSIGHTS_LABEL", Res.string.MAIN_NAVIGATION_INSIGHTS_LABEL)
  map.put("MAIN_NAVIGATION_MAIN_LABEL", Res.string.MAIN_NAVIGATION_MAIN_LABEL)
  map.put("MAIN_NAVIGATION_ME_LABEL", Res.string.MAIN_NAVIGATION_ME_LABEL)
  map.put("MAIN_NAVIGATION_TODAY_LABEL", Res.string.MAIN_NAVIGATION_TODAY_LABEL)
  map.put("MEAL_PLAN_LOG_FOOD_BUTTON", Res.string.MEAL_PLAN_LOG_FOOD_BUTTON)
  map.put("MED_TODAY_SCREEN_TITLE", Res.string.MED_TODAY_SCREEN_TITLE)
  map.put("ME_BMI_GOAL_VALUE_FORMAT", Res.string.ME_BMI_GOAL_VALUE_FORMAT)
  map.put("ME_CALORIES_HISTORY_SECTION", Res.string.ME_CALORIES_HISTORY_SECTION)
  map.put("ME_DAYS_IN_A_ROW_LABEL", Res.string.ME_DAYS_IN_A_ROW_LABEL)
  map.put("ME_DAYS_IN_A_ROW_VALUE", Res.string.ME_DAYS_IN_A_ROW_VALUE)
  map.put("ME_SCREEN_TITLE_FORMAT", Res.string.ME_SCREEN_TITLE_FORMAT)
  map.put("ME_WEIGHT_HISTORY_SECTION", Res.string.ME_WEIGHT_HISTORY_SECTION)
  map.put("ME_WEIGHT_LOSS_PROGRESS_SECTION", Res.string.ME_WEIGHT_LOSS_PROGRESS_SECTION)
  map.put("ME_WEIGHT_LOSS_PROGRESS_VALUE_FORMAT", Res.string.ME_WEIGHT_LOSS_PROGRESS_VALUE_FORMAT)
  map.put("ONBOARDING_SIGN_IN_BUTTON", Res.string.ONBOARDING_SIGN_IN_BUTTON)
  map.put("ONBOARDING_WELCOME_NO_ACCOUNT_BUTTON", Res.string.ONBOARDING_WELCOME_NO_ACCOUNT_BUTTON)
  map.put("ONBOARDING_WELCOME_SIGN_IN_BUTTON", Res.string.ONBOARDING_WELCOME_SIGN_IN_BUTTON)
  map.put("ONBOARDING_WELLNESS_PROFILE_BMI_GRAPH_LABEL", Res.string.ONBOARDING_WELLNESS_PROFILE_BMI_GRAPH_LABEL)
  map.put("ONBOARDING_WELLNESS_PROFILE_YOUR_BMI_FORMAT", Res.string.ONBOARDING_WELLNESS_PROFILE_YOUR_BMI_FORMAT)
  map.put("PAYWALL_OTHER_PLANS_BUTTON", Res.string.PAYWALL_OTHER_PLANS_BUTTON)
  map.put("PAYWALL_PRIVACY_BUTTON", Res.string.PAYWALL_PRIVACY_BUTTON)
  map.put("PAYWALL_RESTORE_BUTTON", Res.string.PAYWALL_RESTORE_BUTTON)
  map.put("PAYWALL_SIGN_IN_BUTTON", Res.string.PAYWALL_SIGN_IN_BUTTON)
  map.put("PAYWALL_TERMS_BUTTON", Res.string.PAYWALL_TERMS_BUTTON)
  map.put("PCOS_TODAY_HEALTH_ADVICE_EMPTY_TEXT", Res.string.PCOS_TODAY_HEALTH_ADVICE_EMPTY_TEXT)
  map.put("PCOS_TODAY_LOG_SYMPTOMS_LABEL", Res.string.PCOS_TODAY_LOG_SYMPTOMS_LABEL)
  map.put("PILATES_TODAY_SCREEN_TITLE", Res.string.PILATES_TODAY_SCREEN_TITLE)
  map.put("PILATES_TODAY_WORKOUTS_SECTION", Res.string.PILATES_TODAY_WORKOUTS_SECTION)
  map.put("RATE_US_ALERT_MESSAGE", Res.string.RATE_US_ALERT_MESSAGE)
  map.put("RATE_US_ALERT_NEGATIVE_BUTTON", Res.string.RATE_US_ALERT_NEGATIVE_BUTTON)
  map.put("RATE_US_ALERT_POSITIVE_BUTTON", Res.string.RATE_US_ALERT_POSITIVE_BUTTON)
  map.put("RATE_US_ALERT_TITLE_FORMAT", Res.string.RATE_US_ALERT_TITLE_FORMAT)
  map.put("RATE_US_IMPROVE_ALERT_NEGATIVE_BUTTON", Res.string.RATE_US_IMPROVE_ALERT_NEGATIVE_BUTTON)
  map.put("RATE_US_IMPROVE_ALERT_POSITIVE_BUTTON", Res.string.RATE_US_IMPROVE_ALERT_POSITIVE_BUTTON)
  map.put("RATE_US_IMPROVE_ALERT_TITLE", Res.string.RATE_US_IMPROVE_ALERT_TITLE)
  map.put("SETTINGS_ABOUT_PRODUCT_LABEL", Res.string.SETTINGS_ABOUT_PRODUCT_LABEL)
  map.put("SETTINGS_CONTACT_US_LABEL", Res.string.SETTINGS_CONTACT_US_LABEL)
  map.put("SETTINGS_DELETE_ACCOUNT_ALERT_MESSAGE", Res.string.SETTINGS_DELETE_ACCOUNT_ALERT_MESSAGE)
  map.put("SETTINGS_DELETE_ACCOUNT_ALERT_TITLE", Res.string.SETTINGS_DELETE_ACCOUNT_ALERT_TITLE)
  map.put("SETTINGS_DELETE_ACCOUNT_LABEL", Res.string.SETTINGS_DELETE_ACCOUNT_LABEL)
  map.put("SETTINGS_DELETE_ACCOUNT_NEGATIVE_BUTTON", Res.string.SETTINGS_DELETE_ACCOUNT_NEGATIVE_BUTTON)
  map.put("SETTINGS_DELETE_ACCOUNT_POSITIVE_BUTTON", Res.string.SETTINGS_DELETE_ACCOUNT_POSITIVE_BUTTON)
  map.put("SETTINGS_GENERAL_SECTION", Res.string.SETTINGS_GENERAL_SECTION)
  map.put("SETTINGS_LEGAL_PRODUCT_LABEL", Res.string.SETTINGS_LEGAL_PRODUCT_LABEL)
  map.put("SETTINGS_LOGOUT_LABEL", Res.string.SETTINGS_LOGOUT_LABEL)
  map.put("SETTINGS_MANAGE_SUBSCRIPTION_LABEL", Res.string.SETTINGS_MANAGE_SUBSCRIPTION_LABEL)
  map.put("SETTINGS_MEAL_PLAN_LABEL", Res.string.SETTINGS_MEAL_PLAN_LABEL)
  map.put("SETTINGS_MEAL_PLAN_SETTINGS_OTHER_SECTION", Res.string.SETTINGS_MEAL_PLAN_SETTINGS_OTHER_SECTION)
  map.put("SETTINGS_MEAL_PLAN_SETTINGS_PERSONAL_SECTION", Res.string.SETTINGS_MEAL_PLAN_SETTINGS_PERSONAL_SECTION)
  map.put("SETTINGS_MEAL_PLAN_SETTINGS_SCREEN_TITLE", Res.string.SETTINGS_MEAL_PLAN_SETTINGS_SCREEN_TITLE)
  map.put("SETTINGS_METRICS_SYSTEM_LABEL", Res.string.SETTINGS_METRICS_SYSTEM_LABEL)
  map.put("SETTINGS_PERIOD_TRACKER_LABEL", Res.string.SETTINGS_PERIOD_TRACKER_LABEL)
  map.put("SETTINGS_PROFILE_AGE_LABEL", Res.string.SETTINGS_PROFILE_AGE_LABEL)
  map.put("SETTINGS_PROFILE_HEIGHT_LABEL", Res.string.SETTINGS_PROFILE_HEIGHT_LABEL)
  map.put("SETTINGS_PROFILE_INITIAL_WEIGHT_LABEL", Res.string.SETTINGS_PROFILE_INITIAL_WEIGHT_LABEL)
  map.put("SETTINGS_PROFILE_NAME_LABEL", Res.string.SETTINGS_PROFILE_NAME_LABEL)
  map.put("SETTINGS_PROFILE_SECTION", Res.string.SETTINGS_PROFILE_SECTION)
  map.put("SETTINGS_PROFILE_TARGET_WEIGHT_LABEL", Res.string.SETTINGS_PROFILE_TARGET_WEIGHT_LABEL)
  map.put("SETTINGS_SCREEN_TITLE", Res.string.SETTINGS_SCREEN_TITLE)
  map.put("SHOPPING_LIST_CATEGORY_ALL_LABEL", Res.string.SHOPPING_LIST_CATEGORY_ALL_LABEL)
  map.put("SHOPPING_LIST_CHECKED_SECTION", Res.string.SHOPPING_LIST_CHECKED_SECTION)
  map.put("SHOPPING_LIST_SCREEN_TITLE", Res.string.SHOPPING_LIST_SCREEN_TITLE)
  map.put("SHOPPING_LIST_UNCHECKED_SECTION", Res.string.SHOPPING_LIST_UNCHECKED_SECTION)
  map.put("TODAY_ACTIVITY_LABEL", Res.string.TODAY_ACTIVITY_LABEL)
  map.put("TODAY_LOGGED_SYMPTOMS_LABEL", Res.string.TODAY_LOGGED_SYMPTOMS_LABEL)
  map.put("TODAY_LOG_CONTROLS_SECTION", Res.string.TODAY_LOG_CONTROLS_SECTION)
  map.put("TODAY_LOG_FOOD_BUTTON", Res.string.TODAY_LOG_FOOD_BUTTON)
  map.put("TODAY_LOG_SYMPTOMS_LABEL", Res.string.TODAY_LOG_SYMPTOMS_LABEL)
  map.put("TODAY_LOG_WATER_BUTTON", Res.string.TODAY_LOG_WATER_BUTTON)
  map.put("TODAY_LOG_WEIGHT_BUTTON", Res.string.TODAY_LOG_WEIGHT_BUTTON)
  map.put("TODAY_MEALS_SECTION", Res.string.TODAY_MEALS_SECTION)
  map.put("TODAY_MEAL_PLAN_SECTION", Res.string.TODAY_MEAL_PLAN_SECTION)
  map.put("TODAY_WATER_INTAKE_LABEL", Res.string.TODAY_WATER_INTAKE_LABEL)
  map.put("TODAY_WATER_INTAKE_SHEET_CLOSE_BUTTON", Res.string.TODAY_WATER_INTAKE_SHEET_CLOSE_BUTTON)
  map.put("TODAY_WATER_INTAKE_SHEET_DAILY_AMOUNT_LABEL", Res.string.TODAY_WATER_INTAKE_SHEET_DAILY_AMOUNT_LABEL)
  map.put("TODAY_WATER_INTAKE_SHEET_TITLE", Res.string.TODAY_WATER_INTAKE_SHEET_TITLE)
  map.put("TODAY_WEIGHT_LABEL", Res.string.TODAY_WEIGHT_LABEL)
  map.put("TUTORIAL_PERSONAL_MEAL_PLAN_DESCRIPTION", Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_DESCRIPTION)
  map.put("TUTORIAL_PERSONAL_MEAL_PLAN_NEGATIVE_BUTTON", Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_NEGATIVE_BUTTON)
  map.put("TUTORIAL_PERSONAL_MEAL_PLAN_POSITIVE_BUTTON", Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_POSITIVE_BUTTON)
  map.put("TUTORIAL_PERSONAL_MEAL_PLAN_TITLE", Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_TITLE)
  map.put("UPDATE_AGE_INFO", Res.string.UPDATE_AGE_INFO)
  map.put("UPDATE_AGE_LOW_AGE_ERROR", Res.string.UPDATE_AGE_LOW_AGE_ERROR)
}
